import React from 'react';
import { PossibleRewardsContainer, PossibleRewardBlock, PossibleRewardCost, PossibleRewardInfo, PossibleRewardTitle, PossibleRewardSubtext } from './styled';
import { SectionHeader, SectionHeaderContainerProps } from '../../components/SectionHeader';
import type { PossibleRewardProps } from './types';
import { getDefaultRewards } from './presets';

export interface PossibleRewardsProps {
  emptyLabel?: boolean;
  sectionHeaderProps?: SectionHeaderContainerProps;
  possibleRewards?: PossibleRewardProps[]; // optional—defaults to presets
}

export const PossibleRewards: React.FC<PossibleRewardsProps> = ({
  sectionHeaderProps,
  possibleRewards,
  emptyLabel = false,
}) => {
  const rewards = (possibleRewards ?? getDefaultRewards()).slice().sort((a, b) => a.rank - b.rank);
  const writtenLabel = emptyLabel ? '' : 'Rewards';

  return (
    <div>
      <SectionHeader
        label={writtenLabel}
        color={sectionHeaderProps?.color}
        borderColor={sectionHeaderProps?.borderColor}
      />
      <PossibleRewardsContainer>
        {rewards.map(pr => (
          <PossibleRewardBlock key={pr.id}>
            <PossibleRewardCost>{pr.imageSrc ? <img src={pr.imageSrc} alt="" /> : null}</PossibleRewardCost>
            <PossibleRewardInfo>
              <PossibleRewardTitle>{pr.title}</PossibleRewardTitle>
              {pr.specialNote && <PossibleRewardSubtext>({pr.specialNote})</PossibleRewardSubtext>}
              <p>{pr.cost} points</p>
            </PossibleRewardInfo>
          </PossibleRewardBlock>
        ))}
      </PossibleRewardsContainer>
    </div>
  );
};
